import { makeLegacyAccessService } from "./accessServiceUtils";

export const creatorVideoAccessService = makeLegacyAccessService({
  contentType: "video",
  itemsKey: "videos",
  grantIdsKey: "videoIds",
});
